<!-- @format -->

@for (studyGroupSet of courseUnitRealisation.studyGroupSets; track studyGroupSet) {
  <div>
    <div role="heading" [attr.aria-level]="subGroupLevel" class="sis-label">{{ studyGroupSet.name | localizedString: language }}</div>
    @for (studySubGroup of studyGroupSet.studySubGroups; track studySubGroup) {
      <app-student-study-sub-group-structure [language]="language" [studySubGroup]="studySubGroup"> </app-student-study-sub-group-structure>
    }
  </div>
}
